<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>设置账号</el-breadcrumb-item>
      </el-breadcrumb>
      <h1 class="view-head">
        设置账号
      </h1>
      <div class="view-content">
        <el-form ref="form" :model="form" :rules="rules" label-width="96px">
          <el-card class="box-card" style="padding: 15px 0px;">
            <div class="card-content">
              <el-form-item label="登陆账号" prop="username">
                <el-input v-model="form.username" class="setAcc"></el-input>
              </el-form-item>
              <el-form-item label="登陆密码" prop="password" class="wipe-mb">
                <el-input v-model="form.password" class="setAcc"></el-input>
              </el-form-item>
            </div>
          </el-card>
          <el-form-item class="no-lable">
            <el-button type="primary" @click="onSubmit('form')" :loading="isLoading">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
</template>

<script>
    export default {
      name: "setAccount",
      data: () => ({
        isLoading: false,
        form: {
          username: '',
          password: '',
        },
        rules: {
          username: [
            {required: true, message: '请输入登陆账号', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请输入登陆密码', trigger: 'blur'}
          ]
        }
      }),
      methods:{
        onSubmit(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.isLoading = true;
              let values = {...this[formName]};
              console.log(values);
            }
          });
        }
      }
    }
</script>

<style scoped>
  .box-card{margin-bottom: 20px;}

</style>